import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.UploadBlock> = (uischema, _schema) => {
  if (uischema.type !== CONTROL_NAME.UPLOAD_CONTROL) {
    throw new Error('Expected a valid Upload control')
  }

  return {
    type: next.BLOCK_TYPE.FILE_UPLOAD,
    settings: {
      ...upCommonSettings(uischema),
      maxQuantity: uischema.options?.maxQuantity ?? 0,
      restricted: Boolean(uischema.options?.restricted),
      supportedTypes: uischema.options?.supportedTypes,
      tags: uischema.options?.tags,
      zoneLabel: uischema.options?.zoneLabel
    },
    references: {}
  }
}
